import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { DeviceUpdateEvidenceFieldPayload } from 'api/actions/device-update-evidence-field/device-update-evidence-field-payload';
import { DeviceUpdateEvidenceFieldPathParameters } from 'api/actions/device-update-evidence-field/device-update-evidence-field-path-parameters';
import { DeviceUpdateEvidenceFieldResponse } from 'api/actions/device-update-evidence-field/device-update-evidence-field-response';

type DeviceUpdateEvidenceFieldQueryParameters = Record<string, any>;

/**
 * The path of the DeviceUpdateEvidenceField action.
 */
export const deviceUpdateEvidenceFieldActionPath = new SweetPath<keyof DeviceUpdateEvidenceFieldPathParameters>(
  '/api/device/evidence-fields/update/{evidenceFieldId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized DeviceUpdateEvidenceField actions.
 */
export default function createDeviceUpdateEvidenceFieldAction(axios: AxiosInstance) {
  return function deviceUpdateEvidenceFieldAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: DeviceUpdateEvidenceFieldPathParameters;
    query?: DeviceUpdateEvidenceFieldQueryParameters;
    payload: DeviceUpdateEvidenceFieldPayload;
  }) {
    const path = deviceUpdateEvidenceFieldActionPath.insert(parameters);

    return axios.request<DeviceUpdateEvidenceFieldResponse, DeviceUpdateEvidenceFieldResponse>({
      method: 'put',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
